import BpkButton, { BUTTON_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-button';
import {
  BpkCardV2,
  CARD_V2_SURFACE_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-card';
import { BpkProvider, BpkSpacing } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { CardIcon } from './CardIcon/CardIcon';

import STYLES from './AppCard.module.scss';

export type AppCardProps = {
  category?: string;
  id: string;
  name: string;
  description: string;
  ctaLabel: string;
  href: string;
  'data-tracking-element-id'?: string;
  'data-tracking-common-params'?: string;
};

export const AppCard = ({
  category,
  ctaLabel,
  'data-tracking-common-params': dataTrackingCommonParams,
  'data-tracking-element-id': dataTrackingElementId,
  description,
  href,
  id,
  name,
}: AppCardProps) => (
  <BpkProvider>
    <BpkLink
      blank
      className={`${STYLES.cardLink} ${STYLES.card}`}
      href={href}
      rel="noopener noreferrer"
      data-tracking-element-id={dataTrackingElementId}
      data-tracking-common-params={dataTrackingCommonParams}
    >
      <div className={STYLES.cardSurface}>
        <BpkCardV2.Root
          bgColor={CARD_V2_SURFACE_COLORS.surfaceLowContrast}
          data-testid="travel-tools-app-card"
        >
          <BpkCardV2.Body padding={BpkSpacing.None}>
            <BpkCardV2.Section padding={BpkSpacing.None}>
              <div className={STYLES.content}>
                <div className={STYLES.copy}>
                  <div className={STYLES.heading}>
                    <div className={STYLES.title}>
                      {category && (
                        <BpkText
                          className={STYLES.category}
                          color={TEXT_COLORS.textSecondary}
                          tagName="p"
                          textStyle={TEXT_STYLES.label1}
                        >
                          {category.toLocaleUpperCase()}
                        </BpkText>
                      )}
                      <BpkText
                        className={STYLES.appName}
                        color={TEXT_COLORS.textPrimary}
                        tagName="h3"
                        textStyle={TEXT_STYLES.heading3}
                      >
                        {name}
                      </BpkText>
                    </div>
                    <div className={STYLES.cta}>
                      <BpkButton
                        aria-hidden="true"
                        tabIndex={-1}
                        type={BUTTON_TYPES.primary}
                        leadingIcon={CardIcon({ id })}
                      >
                        {ctaLabel}
                      </BpkButton>
                    </div>
                  </div>
                  <BpkText
                    className={STYLES.description}
                    color={TEXT_COLORS.textPrimary}
                    tagName="p"
                    textStyle={TEXT_STYLES.bodyDefault}
                  >
                    {description}
                  </BpkText>
                </div>
              </div>
            </BpkCardV2.Section>
          </BpkCardV2.Body>
        </BpkCardV2.Root>
      </div>
    </BpkLink>
  </BpkProvider>
);
